import { t as e } from "./utils-DiFe-_ei.js";
import { i as t, n, r, t as i } from "./dist-By11B3Nf.js";
import { a, n as o } from "./dist-7tgynhKG.js";
import { a as s, c, i as l, l as u, n as d, o as f, r as p, t as m } from "./es2015-Dfq2CQHn.js";
import { n as h, t as g } from "./dist-B3lndwlS.js";
import { t as _ } from "./dist-CUIQpIad.js";
import { t as v } from "./check-hnLqiRGn.js";
import { t as y } from "./chevron-right-C4-3WHKK.js";
import { t as b } from "./circle-CnwCz7ux.js";
import { i as x, n as ee, r as S, t as C } from "./dist-8NAz9rgL.js";
import { n as w, t as te } from "./dist-BCghvxHR.js";
import * as T from "react";
import { jsx as E, jsxs as D } from "react/jsx-runtime";
//#region ../../node_modules/.pnpm/@radix-ui+react-use-is-hydrated@0.1.1_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-use-is-hydrated/dist/index.mjs
var O = !1;
function k() {
	let [e, t] = T.useState(O);
	return T.useEffect(() => {
		O || (O = !0, t(!0));
	}, []), e;
}
var A = T.useSyncExternalStore;
function ne() {
	return () => {};
}
function j() {
	return A(ne, () => !0, () => !1);
}
var M = typeof A == "function" ? j : k, re = Object.defineProperty, N = (e, t) => re(e, "name", {
	value: t,
	configurable: !0
}), P = "rovingFocusGroup.onEntryFocus", F = {
	bubbles: !1,
	cancelable: !0
}, I = "RovingFocusGroup", [L, R, z] = w(I), [ie, ae] = t(I, [z]), [oe, se] = ie(I), ce = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ N(function(e, t) {
	return /* @__PURE__ */ E(L.Provider, {
		scope: e.__scopeRovingFocusGroup,
		children: /* @__PURE__ */ E(L.Slot, {
			scope: e.__scopeRovingFocusGroup,
			children: /* @__PURE__ */ E(le, {
				...e,
				ref: t
			})
		})
	});
}, "RovingFocusGroup")), le = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ N(function(e, t) {
	let { __scopeRovingFocusGroup: n, orientation: o, loop: s = !1, dir: l, currentTabStopId: u, defaultCurrentTabStopId: d, onCurrentTabStopIdChange: f, onEntryFocus: p, preventScrollOnEntryFocus: m = !1, ...h } = e, _ = T.useRef(null), v = a(t, _), y = te(l), [b, x] = i({
		prop: u,
		defaultProp: d ?? null,
		onChange: f,
		caller: I
	}), [ee, S] = T.useState(!1), C = c(p), w = R(n), D = T.useRef(!1), [O, k] = T.useState(0);
	return T.useEffect(() => {
		let e = _.current;
		if (e) return e.addEventListener(P, C), () => e.removeEventListener(P, C);
	}, [C]), /* @__PURE__ */ E(oe, {
		scope: n,
		orientation: o,
		dir: y,
		loop: s,
		currentTabStopId: b,
		onItemFocus: T.useCallback((e) => x(e), [x]),
		onItemShiftTab: T.useCallback(() => S(!0), []),
		onFocusableItemAdd: T.useCallback(() => k((e) => e + 1), []),
		onFocusableItemRemove: T.useCallback(() => k((e) => e - 1), []),
		children: /* @__PURE__ */ E(g.div, {
			tabIndex: ee || O === 0 ? -1 : 0,
			"data-orientation": o,
			...h,
			ref: v,
			style: {
				outline: "none",
				...e.style
			},
			onMouseDown: r(e.onMouseDown, () => {
				D.current = !0;
			}),
			onFocus: r(e.onFocus, (e) => {
				let t = !D.current;
				if (e.target === e.currentTarget && t && !ee) {
					let t = new CustomEvent(P, F);
					if (e.currentTarget.dispatchEvent(t), !t.defaultPrevented) {
						let e = w().filter((e) => e.focusable);
						he([
							e.find((e) => e.active),
							e.find((e) => e.id === b),
							...e
						].filter(Boolean).map((e) => e.ref.current), m);
					}
				}
				D.current = !1;
			}),
			onBlur: r(e.onBlur, () => S(!1))
		})
	});
}, "RovingFocusGroupImpl")), ue = "RovingFocusGroupItem", de = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ N(function(e, t) {
	let { __scopeRovingFocusGroup: i, focusable: a = !0, active: o = !1, tabStopId: s, children: c, ...l } = e, d = u(), f = s || d, p = se(ue, i), m = p.currentTabStopId === f, h = R(i), { onFocusableItemAdd: _, onFocusableItemRemove: v, currentTabStopId: y } = p, b = M();
	return n(() => {
		if (!(!b || !a)) return _(), () => v();
	}, [
		b,
		a,
		_,
		v
	]), T.useEffect(() => {
		if (!(b || !a)) return _(), () => v();
	}, [
		b,
		a,
		_,
		v
	]), /* @__PURE__ */ E(L.ItemSlot, {
		scope: i,
		id: f,
		focusable: a,
		active: o,
		children: /* @__PURE__ */ E(g.span, {
			tabIndex: m ? 0 : -1,
			"data-orientation": p.orientation,
			...l,
			ref: t,
			onMouseDown: r(e.onMouseDown, (e) => {
				a ? p.onItemFocus(f) : e.preventDefault();
			}),
			onFocus: r(e.onFocus, () => p.onItemFocus(f)),
			onKeyDown: r(e.onKeyDown, (e) => {
				if (e.key === "Tab" && e.shiftKey) {
					p.onItemShiftTab();
					return;
				}
				if (e.target !== e.currentTarget) return;
				let t = me(e, p.orientation, p.dir);
				if (t !== void 0) {
					if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey) return;
					e.preventDefault();
					let n = h().filter((e) => e.focusable).map((e) => e.ref.current);
					if (t === "last") n.reverse();
					else if (t === "prev" || t === "next") {
						t === "prev" && n.reverse();
						let r = n.indexOf(e.currentTarget);
						n = p.loop ? ge(n, r + 1) : n.slice(r + 1);
					}
					setTimeout(() => he(n));
				}
			}),
			children: typeof c == "function" ? c({
				isCurrentTabStop: m,
				hasTabStop: y != null
			}) : c
		})
	});
}, "RovingFocusGroupItem")), fe = {
	ArrowLeft: "prev",
	ArrowUp: "prev",
	ArrowRight: "next",
	ArrowDown: "next",
	PageUp: "first",
	Home: "first",
	PageDown: "last",
	End: "last"
};
function pe(e, t) {
	return t === "rtl" ? e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e : e;
}
N(pe, "getDirectionAwareKey");
function me(e, t, n) {
	let r = pe(e.key, n);
	if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r))) return fe[r];
}
N(me, "getFocusIntent");
function he(e, t = !1) {
	let n = document.activeElement;
	for (let r of e) if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
N(he, "focusFirst");
function ge(e, t) {
	return e.map((n, r) => e[(t + r) % e.length]);
}
N(ge, "wrapArray");
var _e = ce, ve = de, ye = Object.defineProperty, B = (e, t) => ye(e, "name", {
	value: t,
	configurable: !0
}), be = ["Enter", " "], xe = [
	"ArrowDown",
	"PageUp",
	"Home"
], Se = [
	"ArrowUp",
	"PageDown",
	"End"
], Ce = [...xe, ...Se], we = {
	ltr: [...be, "ArrowRight"],
	rtl: [...be, "ArrowLeft"]
}, Te = {
	ltr: ["ArrowLeft"],
	rtl: ["ArrowRight"]
}, V = "Menu", [H, Ee, De] = w(V), [U, Oe] = t(V, [
	De,
	x,
	ae
]), W = x(), ke = ae(), [Ae, G] = U(V), [je, K] = U(V), Me = /* @__PURE__ */ B((e) => {
	let { __scopeMenu: t, open: n = !1, children: r, dir: i, onOpenChange: a, modal: o = !0 } = e, s = W(t), [l, u] = T.useState(null), d = T.useRef(!1), f = c(a), p = te(i);
	return T.useEffect(() => {
		let e = /* @__PURE__ */ B(() => {
			d.current = !0, document.addEventListener("pointerdown", t, {
				capture: !0,
				once: !0
			}), document.addEventListener("pointermove", t, {
				capture: !0,
				once: !0
			});
		}, "handleKeyDown"), t = /* @__PURE__ */ B(() => d.current = !1, "handlePointer");
		return document.addEventListener("keydown", e, { capture: !0 }), () => {
			document.removeEventListener("keydown", e, { capture: !0 }), document.removeEventListener("pointerdown", t, { capture: !0 }), document.removeEventListener("pointermove", t, { capture: !0 });
		};
	}, []), T.useEffect(() => {
		if (!n) return;
		let e = /* @__PURE__ */ B(() => f(!1), "handleBlur");
		return window.addEventListener("blur", e), () => window.removeEventListener("blur", e);
	}, [n, f]), /* @__PURE__ */ E(S, {
		...s,
		children: /* @__PURE__ */ E(Ae, {
			scope: t,
			open: n,
			onOpenChange: f,
			content: l,
			onContentChange: u,
			children: /* @__PURE__ */ E(je, {
				scope: t,
				onClose: T.useCallback(() => f(!1), [f]),
				isUsingKeyboardRef: d,
				dir: p,
				modal: o,
				children: r
			})
		})
	});
}, "Menu"), Ne = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ B(function(e, t) {
	let { __scopeMenu: n, ...r } = e;
	return /* @__PURE__ */ E(C, {
		...W(n),
		...r,
		ref: t
	});
}, "MenuAnchor")), Pe = "MenuPortal", [Fe, Ie] = U(Pe, { forceMount: void 0 }), Le = /* @__PURE__ */ B((e) => {
	let { __scopeMenu: t, forceMount: n, children: r, container: i } = e, a = G(Pe, t);
	return /* @__PURE__ */ E(Fe, {
		scope: t,
		forceMount: n,
		children: /* @__PURE__ */ E(_, {
			present: n || a.open,
			children: /* @__PURE__ */ E(l, {
				asChild: !0,
				container: i,
				children: r
			})
		})
	});
}, "MenuPortal"), q = "MenuContent", [Re, ze] = U(q), Be = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ B(function(e, t) {
	let n = Ie(q, e.__scopeMenu), { forceMount: r = n.forceMount, ...i } = e, a = G(q, e.__scopeMenu), o = K(q, e.__scopeMenu);
	return /* @__PURE__ */ E(H.Provider, {
		scope: e.__scopeMenu,
		children: /* @__PURE__ */ E(_, {
			present: r || a.open,
			children: /* @__PURE__ */ E(H.Slot, {
				scope: e.__scopeMenu,
				children: o.modal ? /* @__PURE__ */ E(Ve, {
					...i,
					ref: t
				}) : /* @__PURE__ */ E(He, {
					...i,
					ref: t
				})
			})
		})
	});
}, "MenuContent")), Ve = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ B(function(e, t) {
	let n = G(q, e.__scopeMenu), i = T.useRef(null), o = a(t, i);
	return T.useEffect(() => {
		let e = i.current;
		if (e) return m(e);
	}, []), /* @__PURE__ */ E(We, {
		...e,
		ref: o,
		trapFocus: n.open,
		disableOutsidePointerEvents: n.open,
		disableOutsideScroll: !0,
		onFocusOutside: r(e.onFocusOutside, (e) => e.preventDefault(), { checkForDefaultPrevented: !1 }),
		onDismiss: () => n.onOpenChange(!1)
	});
}, "MenuRootContentModal")), He = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ B(function(e, t) {
	let n = G(q, e.__scopeMenu);
	return /* @__PURE__ */ E(We, {
		...e,
		ref: t,
		trapFocus: !1,
		disableOutsidePointerEvents: !1,
		disableOutsideScroll: !1,
		onDismiss: () => n.onOpenChange(!1)
	});
}, "MenuRootContentNonModal")), Ue = o("MenuContent.ScrollLock"), We = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ B(function(e, t) {
	let { __scopeMenu: n, loop: i = !1, trapFocus: o, onOpenAutoFocus: c, onCloseAutoFocus: l, disableOutsidePointerEvents: u, onEntryFocus: m, onEscapeKeyDown: h, onPointerDownOutside: g, onFocusOutside: _, onInteractOutside: v, onDismiss: y, disableOutsideScroll: b, ...x } = e, S = G(q, n), C = K(q, n), w = W(n), te = ke(n), D = Ee(n), [O, k] = T.useState(null), A = T.useRef(null), ne = a(t, A, S.onContentChange), j = T.useRef(0), M = T.useRef(""), re = T.useRef(0), N = T.useRef(null), P = T.useRef("right"), F = T.useRef(0), I = b ? d : T.Fragment, L = b ? {
		as: Ue,
		allowPinchZoom: !0
	} : void 0, R = /* @__PURE__ */ B((e) => {
		let t = M.current + e, n = D().filter((e) => !e.disabled), r = document.activeElement, i = n.find((e) => e.ref.current === r)?.textValue, a = vt(n.map((e) => e.textValue), t, i), o = n.find((e) => e.textValue === a)?.ref.current;
		(/* @__PURE__ */ B((function e(t) {
			M.current = t, window.clearTimeout(j.current), t !== "" && (j.current = window.setTimeout(() => e(""), 1e3));
		}), "updateSearch"))(t), o && setTimeout(() => o.focus());
	}, "handleTypeaheadSearch");
	T.useEffect(() => () => window.clearTimeout(j.current), []), p();
	let z = T.useCallback((e) => P.current === N.current?.side && bt(e, N.current?.area), []);
	return /* @__PURE__ */ E(Re, {
		scope: n,
		searchRef: M,
		onItemEnter: T.useCallback((e) => {
			z(e) && e.preventDefault();
		}, [z]),
		onItemLeave: T.useCallback((e) => {
			z(e) || (A.current?.focus(), k(null));
		}, [z]),
		onTriggerLeave: T.useCallback((e) => {
			z(e) && e.preventDefault();
		}, [z]),
		pointerGraceTimerRef: re,
		onPointerGraceIntentChange: T.useCallback((e) => {
			N.current = e;
		}, []),
		children: /* @__PURE__ */ E(I, {
			...L,
			children: /* @__PURE__ */ E(s, {
				asChild: !0,
				trapped: o,
				onMountAutoFocus: r(c, (e) => {
					e.preventDefault(), A.current?.focus({ preventScroll: !0 });
				}),
				onUnmountAutoFocus: l,
				children: /* @__PURE__ */ E(f, {
					asChild: !0,
					disableOutsidePointerEvents: u,
					onEscapeKeyDown: h,
					onPointerDownOutside: g,
					onFocusOutside: _,
					onInteractOutside: v,
					onDismiss: y,
					children: /* @__PURE__ */ E(_e, {
						asChild: !0,
						...te,
						dir: C.dir,
						orientation: "vertical",
						loop: i,
						currentTabStopId: O,
						onCurrentTabStopIdChange: k,
						onEntryFocus: r(m, (e) => {
							C.isUsingKeyboardRef.current || e.preventDefault();
						}),
						preventScrollOnEntryFocus: !0,
						children: /* @__PURE__ */ E(ee, {
							role: "menu",
							"aria-orientation": "vertical",
							"data-state": ht(S.open),
							"data-radix-menu-content": "",
							dir: C.dir,
							...w,
							...x,
							ref: ne,
							style: {
								outline: "none",
								...x.style
							},
							onKeyDown: r(x.onKeyDown, (e) => {
								let t = e.target.closest("[data-radix-menu-content]") === e.currentTarget, n = e.ctrlKey || e.altKey || e.metaKey, r = e.key.length === 1;
								t && (e.key === "Tab" && e.preventDefault(), !n && r && R(e.key));
								let i = A.current;
								if (e.target !== i || !Ce.includes(e.key)) return;
								e.preventDefault();
								let a = D().filter((e) => !e.disabled).map((e) => e.ref.current);
								Se.includes(e.key) && a.reverse(), gt(a);
							}),
							onBlur: r(e.onBlur, (e) => {
								e.currentTarget.contains(e.target) || (window.clearTimeout(j.current), M.current = "");
							}),
							onPointerMove: r(e.onPointerMove, Z((e) => {
								let t = e.target, n = F.current !== e.clientX;
								if (e.currentTarget.contains(t) && n) {
									let t = e.clientX > F.current ? "right" : "left";
									P.current = t, F.current = e.clientX;
								}
							}))
						})
					})
				})
			})
		})
	});
}, "MenuContentImpl")), Ge = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ B(function(e, t) {
	let { __scopeMenu: n, ...r } = e;
	return /* @__PURE__ */ E(g.div, {
		role: "group",
		...r,
		ref: t
	});
}, "MenuGroup")), Ke = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ B(function(e, t) {
	let { __scopeMenu: n, ...r } = e;
	return /* @__PURE__ */ E(g.div, {
		...r,
		ref: t
	});
}, "MenuLabel")), qe = "MenuItem", Je = "menu.itemSelect", Ye = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ B(function(e, t) {
	let { disabled: n = !1, onSelect: i, ...o } = e, s = T.useRef(null), c = K(qe, e.__scopeMenu), l = ze(qe, e.__scopeMenu), u = a(t, s), d = T.useRef(!1), f = /* @__PURE__ */ B(() => {
		let e = s.current;
		if (!n && e) {
			let t = new CustomEvent(Je, {
				bubbles: !0,
				cancelable: !0
			});
			e.addEventListener(Je, (e) => i?.(e), { once: !0 }), h(e, t), t.defaultPrevented ? d.current = !1 : c.onClose();
		}
	}, "handleSelect");
	return /* @__PURE__ */ E(Xe, {
		...o,
		ref: u,
		disabled: n,
		onClick: r(e.onClick, f),
		onPointerDown: (t) => {
			e.onPointerDown?.(t), d.current = !0;
		},
		onPointerUp: r(e.onPointerUp, (e) => {
			d.current || e.currentTarget?.click();
		}),
		onKeyDown: r(e.onKeyDown, (e) => {
			n || e.target !== e.currentTarget || l.searchRef.current !== "" && e.key === " " || be.includes(e.key) && (e.currentTarget.click(), e.preventDefault());
		})
	});
}, "MenuItem")), Xe = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ B(function(e, t) {
	let { __scopeMenu: n, disabled: i = !1, textValue: o, ...s } = e, c = ze(qe, n), l = ke(n), u = T.useRef(null), d = a(t, u), [f, p] = T.useState(!1), [m, h] = T.useState("");
	return T.useEffect(() => {
		let e = u.current;
		e && h((e.textContent ?? "").trim());
	}, [s.children]), /* @__PURE__ */ E(H.ItemSlot, {
		scope: n,
		disabled: i,
		textValue: o ?? m,
		children: /* @__PURE__ */ E(ve, {
			asChild: !0,
			...l,
			focusable: !i,
			children: /* @__PURE__ */ E(g.div, {
				role: "menuitem",
				"data-highlighted": f ? "" : void 0,
				"aria-disabled": i || void 0,
				"data-disabled": i ? "" : void 0,
				...s,
				ref: d,
				onPointerMove: r(e.onPointerMove, Z((e) => {
					i ? c.onItemLeave(e) : (c.onItemEnter(e), e.defaultPrevented || e.currentTarget.focus({ preventScroll: !0 }));
				})),
				onPointerLeave: r(e.onPointerLeave, Z((e) => c.onItemLeave(e))),
				onFocus: r(e.onFocus, () => p(!0)),
				onBlur: r(e.onBlur, () => p(!1))
			})
		})
	});
}, "MenuItemImpl")), Ze = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ B(function(e, t) {
	let { checked: n = !1, onCheckedChange: i, ...a } = e;
	return /* @__PURE__ */ E(it, {
		scope: e.__scopeMenu,
		checked: n,
		children: /* @__PURE__ */ E(Ye, {
			role: "menuitemcheckbox",
			"aria-checked": Y(n) ? "mixed" : n,
			...a,
			ref: t,
			"data-state": X(n),
			onSelect: r(a.onSelect, () => i?.(Y(n) ? !0 : !n), { checkForDefaultPrevented: !1 })
		})
	});
}, "MenuCheckboxItem")), [Qe, $e] = U("MenuRadioGroup", {
	value: void 0,
	onValueChange: /* @__PURE__ */ B(() => {}, "onValueChange")
}), et = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ B(function(e, t) {
	let { value: n, onValueChange: r, ...i } = e, a = c(r);
	return /* @__PURE__ */ E(Qe, {
		scope: e.__scopeMenu,
		value: n,
		onValueChange: a,
		children: /* @__PURE__ */ E(Ge, {
			...i,
			ref: t
		})
	});
}, "MenuRadioGroup")), tt = "MenuRadioItem", nt = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ B(function(e, t) {
	let { value: n, ...i } = e, a = $e(tt, e.__scopeMenu), o = n === a.value;
	return /* @__PURE__ */ E(it, {
		scope: e.__scopeMenu,
		checked: o,
		children: /* @__PURE__ */ E(Ye, {
			role: "menuitemradio",
			"aria-checked": o,
			...i,
			ref: t,
			"data-state": X(o),
			onSelect: r(i.onSelect, () => a.onValueChange?.(n), { checkForDefaultPrevented: !1 })
		})
	});
}, "MenuRadioItem")), rt = "MenuItemIndicator", [it, at] = U(rt, { checked: !1 }), ot = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ B(function(e, t) {
	let { __scopeMenu: n, forceMount: r, ...i } = e, a = at(rt, n);
	return /* @__PURE__ */ E(_, {
		present: r || Y(a.checked) || a.checked === !0,
		children: /* @__PURE__ */ E(g.span, {
			...i,
			ref: t,
			"data-state": X(a.checked)
		})
	});
}, "MenuItemIndicator")), st = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ B(function(e, t) {
	let { __scopeMenu: n, ...r } = e;
	return /* @__PURE__ */ E(g.div, {
		role: "separator",
		"aria-orientation": "horizontal",
		...r,
		ref: t
	});
}, "MenuSeparator")), ct = "MenuSub", [lt, ut] = U(ct), dt = /* @__PURE__ */ B((e) => {
	let { __scopeMenu: t, children: n, open: r = !1, onOpenChange: i } = e, a = G(ct, t), o = W(t), [s, l] = T.useState(null), [d, f] = T.useState(null), p = c(i);
	return T.useEffect(() => (a.open === !1 && p(!1), () => p(!1)), [a.open, p]), /* @__PURE__ */ E(S, {
		...o,
		children: /* @__PURE__ */ E(Ae, {
			scope: t,
			open: r,
			onOpenChange: p,
			content: d,
			onContentChange: f,
			children: /* @__PURE__ */ E(lt, {
				scope: t,
				contentId: u(),
				triggerId: u(),
				trigger: s,
				onTriggerChange: l,
				children: n
			})
		})
	});
}, "MenuSub"), J = "MenuSubTrigger", ft = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ B(function(e, t) {
	let n = G(J, e.__scopeMenu), i = K(J, e.__scopeMenu), o = ut(J, e.__scopeMenu), s = ze(J, e.__scopeMenu), c = T.useRef(null), { pointerGraceTimerRef: l, onPointerGraceIntentChange: u } = s, d = { __scopeMenu: e.__scopeMenu }, f = T.useCallback(() => {
		c.current && window.clearTimeout(c.current), c.current = null;
	}, []);
	T.useEffect(() => f, [f]), T.useEffect(() => {
		let e = l.current;
		return () => {
			window.clearTimeout(e), u(null);
		};
	}, [l, u]);
	let p = a(t, o.onTriggerChange);
	return /* @__PURE__ */ E(Ne, {
		asChild: !0,
		...d,
		children: /* @__PURE__ */ E(Xe, {
			id: o.triggerId,
			"aria-haspopup": "menu",
			"aria-expanded": n.open,
			"aria-controls": n.open ? o.contentId : void 0,
			"data-state": ht(n.open),
			...e,
			ref: p,
			onClick: (t) => {
				e.onClick?.(t), !(e.disabled || t.defaultPrevented) && (t.currentTarget.focus(), n.open || n.onOpenChange(!0));
			},
			onPointerMove: r(e.onPointerMove, Z((t) => {
				s.onItemEnter(t), !t.defaultPrevented && !e.disabled && !n.open && !c.current && (s.onPointerGraceIntentChange(null), c.current = window.setTimeout(() => {
					n.onOpenChange(!0), f();
				}, 100));
			})),
			onPointerLeave: r(e.onPointerLeave, Z((e) => {
				f();
				let t = n.content?.getBoundingClientRect();
				if (t) {
					let r = n.content?.dataset.side, i = r === "right", a = i ? -5 : 5, o = t[i ? "left" : "right"], c = t[i ? "right" : "left"];
					s.onPointerGraceIntentChange({
						area: [
							{
								x: e.clientX + a,
								y: e.clientY
							},
							{
								x: o,
								y: t.top
							},
							{
								x: c,
								y: t.top
							},
							{
								x: c,
								y: t.bottom
							},
							{
								x: o,
								y: t.bottom
							}
						],
						side: r
					}), window.clearTimeout(l.current), l.current = window.setTimeout(() => s.onPointerGraceIntentChange(null), 300);
				} else {
					if (s.onTriggerLeave(e), e.defaultPrevented) return;
					s.onPointerGraceIntentChange(null);
				}
			})),
			onKeyDown: r(e.onKeyDown, (t) => {
				e.disabled || t.target !== t.currentTarget || s.searchRef.current !== "" && t.key === " " || we[i.dir].includes(t.key) && (n.onOpenChange(!0), n.content?.focus(), t.preventDefault());
			})
		})
	});
}, "MenuSubTrigger")), pt = "MenuSubContent", mt = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ B(function(e, t) {
	let n = Ie(q, e.__scopeMenu), { forceMount: i = n.forceMount, align: o = "start", ...s } = e, c = G(q, e.__scopeMenu), l = K(q, e.__scopeMenu), u = ut(pt, e.__scopeMenu), d = T.useRef(null), f = a(t, d);
	return /* @__PURE__ */ E(H.Provider, {
		scope: e.__scopeMenu,
		children: /* @__PURE__ */ E(_, {
			present: i || c.open,
			children: /* @__PURE__ */ E(H.Slot, {
				scope: e.__scopeMenu,
				children: /* @__PURE__ */ E(We, {
					id: u.contentId,
					"aria-labelledby": u.triggerId,
					...s,
					ref: f,
					align: o,
					side: l.dir === "rtl" ? "left" : "right",
					disableOutsidePointerEvents: !1,
					disableOutsideScroll: !1,
					trapFocus: !1,
					onOpenAutoFocus: (e) => {
						l.isUsingKeyboardRef.current && d.current?.focus(), e.preventDefault();
					},
					onCloseAutoFocus: (e) => e.preventDefault(),
					onFocusOutside: r(e.onFocusOutside, (e) => {
						e.target !== u.trigger && c.onOpenChange(!1);
					}),
					onEscapeKeyDown: r(e.onEscapeKeyDown, (e) => {
						l.onClose(), e.preventDefault();
					}),
					onKeyDown: r(e.onKeyDown, (e) => {
						let t = e.currentTarget.contains(e.target), n = Te[l.dir].includes(e.key);
						t && n && (c.onOpenChange(!1), u.trigger?.focus(), e.preventDefault());
					})
				})
			})
		})
	});
}, "MenuSubContent"));
function ht(e) {
	return e ? "open" : "closed";
}
B(ht, "getOpenState");
function Y(e) {
	return e === "indeterminate";
}
B(Y, "isIndeterminate");
function X(e) {
	return Y(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
B(X, "getCheckedState");
function gt(e) {
	let t = document.activeElement;
	for (let n of e) if (n === t || (n.focus(), document.activeElement !== t)) return;
}
B(gt, "focusFirst");
function _t(e, t) {
	return e.map((n, r) => e[(t + r) % e.length]);
}
B(_t, "wrapArray");
function vt(e, t, n) {
	let r = t.length > 1 && Array.from(t).every((e) => e === t[0]) ? t[0] : t, i = n ? e.indexOf(n) : -1, a = _t(e, Math.max(i, 0));
	r.length === 1 && (a = a.filter((e) => e !== n));
	let o = a.find((e) => e.toLowerCase().startsWith(r.toLowerCase()));
	return o === n ? void 0 : o;
}
B(vt, "getNextMatch");
function yt(e, t) {
	let { x: n, y: r } = e, i = !1;
	for (let e = 0, a = t.length - 1; e < t.length; a = e++) {
		let o = t[e], s = t[a], c = o.x, l = o.y, u = s.x, d = s.y;
		l > r != d > r && n < (u - c) * (r - l) / (d - l) + c && (i = !i);
	}
	return i;
}
B(yt, "isPointInPolygon");
function bt(e, t) {
	return t ? yt({
		x: e.clientX,
		y: e.clientY
	}, t) : !1;
}
B(bt, "isPointerInGraceArea");
function Z(e) {
	return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
B(Z, "whenMouse");
var xt = Me, St = Ne, Ct = Le, wt = Be, Tt = Ge, Et = Ke, Dt = Ye, Ot = Ze, kt = et, At = nt, jt = ot, Mt = st, Nt = dt, Pt = ft, Ft = mt, It = Object.defineProperty, Q = (e, t) => It(e, "name", {
	value: t,
	configurable: !0
}), Lt = "DropdownMenu", [Rt, zt] = t(Lt, [Oe]), $ = Oe(), [Bt, Vt] = Rt(Lt), Ht = /* @__PURE__ */ Q((e) => {
	let { __scopeDropdownMenu: t, children: n, dir: r, open: a, defaultOpen: o, onOpenChange: s, modal: c = !0 } = e, l = $(t), d = T.useRef(null), [f, p] = i({
		prop: a,
		defaultProp: o ?? !1,
		onChange: s,
		caller: Lt
	});
	return /* @__PURE__ */ E(Bt, {
		scope: t,
		triggerId: u(),
		triggerRef: d,
		contentId: u(),
		open: f,
		onOpenChange: p,
		onOpenToggle: T.useCallback(() => p((e) => !e), [p]),
		modal: c,
		children: /* @__PURE__ */ E(xt, {
			...l,
			open: f,
			onOpenChange: p,
			dir: r,
			modal: c,
			children: n
		})
	});
}, "DropdownMenu"), Ut = "DropdownMenuTrigger", Wt = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDropdownMenu: n, disabled: i = !1, ...o } = e, s = Vt(Ut, n), c = $(n), l = a(t, s.triggerRef);
	return /* @__PURE__ */ E(St, {
		asChild: !0,
		...c,
		children: /* @__PURE__ */ E(g.button, {
			type: "button",
			id: s.triggerId,
			"aria-haspopup": "menu",
			"aria-expanded": s.open,
			"aria-controls": s.open ? s.contentId : void 0,
			"data-state": s.open ? "open" : "closed",
			"data-disabled": i ? "" : void 0,
			disabled: i,
			...o,
			ref: l,
			onPointerDown: r(e.onPointerDown, (e) => {
				!i && e.button === 0 && e.ctrlKey === !1 && (s.onOpenToggle(), s.open || e.preventDefault());
			}),
			onKeyDown: r(e.onKeyDown, (e) => {
				i || (["Enter", " "].includes(e.key) && s.onOpenToggle(), e.key === "ArrowDown" && s.onOpenChange(!0), [
					"Enter",
					" ",
					"ArrowDown"
				].includes(e.key) && e.preventDefault());
			})
		})
	});
}, "DropdownMenuTrigger")), Gt = /* @__PURE__ */ Q((e) => {
	let { __scopeDropdownMenu: t, ...n } = e;
	return /* @__PURE__ */ E(Ct, {
		...$(t),
		...n
	});
}, "DropdownMenuPortal"), Kt = "DropdownMenuContent", qt = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDropdownMenu: n, ...i } = e, a = Vt(Kt, n), o = $(n), s = T.useRef(!1);
	return /* @__PURE__ */ E(wt, {
		id: a.contentId,
		"aria-labelledby": a.triggerId,
		...o,
		...i,
		ref: t,
		onCloseAutoFocus: r(e.onCloseAutoFocus, (e) => {
			s.current || a.triggerRef.current?.focus(), s.current = !1, e.preventDefault();
		}),
		onInteractOutside: r(e.onInteractOutside, (e) => {
			let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0, r = t.button === 2 || n;
			(!a.modal || r) && (s.current = !0);
		}),
		style: {
			...e.style,
			"--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
			"--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
			"--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
			"--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
			"--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
		}
	});
}, "DropdownMenuContent")), Jt = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e;
	return /* @__PURE__ */ E(Tt, {
		...$(n),
		...r,
		ref: t
	});
}, "DropdownMenuGroup")), Yt = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e;
	return /* @__PURE__ */ E(Et, {
		...$(n),
		...r,
		ref: t
	});
}, "DropdownMenuLabel")), Xt = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e;
	return /* @__PURE__ */ E(Dt, {
		...$(n),
		...r,
		ref: t
	});
}, "DropdownMenuItem")), Zt = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e;
	return /* @__PURE__ */ E(Ot, {
		...$(n),
		...r,
		ref: t
	});
}, "DropdownMenuCheckboxItem")), Qt = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e;
	return /* @__PURE__ */ E(kt, {
		...$(n),
		...r,
		ref: t
	});
}, "DropdownMenuRadioGroup")), $t = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e;
	return /* @__PURE__ */ E(At, {
		...$(n),
		...r,
		ref: t
	});
}, "DropdownMenuRadioItem")), en = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e;
	return /* @__PURE__ */ E(jt, {
		...$(n),
		...r,
		ref: t
	});
}, "DropdownMenuItemIndicator")), tn = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e;
	return /* @__PURE__ */ E(Mt, {
		...$(n),
		...r,
		ref: t
	});
}, "DropdownMenuSeparator")), nn = /* @__PURE__ */ Q((e) => {
	let { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: a, defaultOpen: o } = e, s = $(t), [c, l] = i({
		prop: r,
		defaultProp: o ?? !1,
		onChange: a,
		caller: "DropdownMenuSub"
	});
	return /* @__PURE__ */ E(Nt, {
		...s,
		open: c,
		onOpenChange: l,
		children: n
	});
}, "DropdownMenuSub"), rn = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e;
	return /* @__PURE__ */ E(Pt, {
		...$(n),
		...r,
		ref: t
	});
}, "DropdownMenuSubTrigger")), an = /* @__PURE__ */ T.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDropdownMenu: n, ...r } = e;
	return /* @__PURE__ */ E(Ft, {
		...$(n),
		...r,
		ref: t,
		style: {
			...e.style,
			"--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
			"--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
			"--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
			"--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
			"--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
		}
	});
}, "DropdownMenuSubContent")), on = Ht, sn = Wt, cn = Gt, ln = qt, un = Jt, dn = Yt, fn = Xt, pn = Zt, mn = Qt, hn = $t, gn = en, _n = tn, vn = nn, yn = rn, bn = an, xn = on, Sn = sn, Cn = un, wn = cn, Tn = vn, En = mn, Dn = T.forwardRef(({ className: t, inset: n, children: r, ...i }, a) => /* @__PURE__ */ D(yn, {
	ref: a,
	className: e("flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0", n && "pl-8", t),
	...i,
	children: [r, /* @__PURE__ */ E(y, { className: "ml-auto" })]
}));
Dn.displayName = yn.displayName;
var On = T.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ E(bn, {
	ref: r,
	className: e("z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-dropdown-menu-content-transform-origin]", t),
	...n
}));
On.displayName = bn.displayName;
var kn = T.forwardRef(({ className: t, sideOffset: n = 4, ...r }, i) => /* @__PURE__ */ E(cn, { children: /* @__PURE__ */ E(ln, {
	ref: i,
	sideOffset: n,
	className: e("z-50 max-h-[var(--radix-dropdown-menu-content-available-height)] min-w-[8rem] overflow-y-auto overflow-x-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-dropdown-menu-content-transform-origin]", t),
	...r
}) }));
kn.displayName = ln.displayName;
var An = T.forwardRef(({ className: t, inset: n, ...r }, i) => /* @__PURE__ */ E(fn, {
	ref: i,
	className: e("relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0", n && "pl-8", t),
	...r
}));
An.displayName = fn.displayName;
var jn = T.forwardRef(({ className: t, children: n, checked: r, ...i }, a) => /* @__PURE__ */ D(pn, {
	ref: a,
	className: e("relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", t),
	checked: r,
	...i,
	children: [/* @__PURE__ */ E("span", {
		className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
		children: /* @__PURE__ */ E(gn, { children: /* @__PURE__ */ E(v, { className: "h-4 w-4" }) })
	}), n]
}));
jn.displayName = pn.displayName;
var Mn = T.forwardRef(({ className: t, children: n, ...r }, i) => /* @__PURE__ */ D(hn, {
	ref: i,
	className: e("relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50", t),
	...r,
	children: [/* @__PURE__ */ E("span", {
		className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center",
		children: /* @__PURE__ */ E(gn, { children: /* @__PURE__ */ E(b, { className: "h-2 w-2 fill-current" }) })
	}), n]
}));
Mn.displayName = hn.displayName;
var Nn = T.forwardRef(({ className: t, inset: n, ...r }, i) => /* @__PURE__ */ E(dn, {
	ref: i,
	className: e("px-2 py-1.5 text-sm font-semibold", n && "pl-8", t),
	...r
}));
Nn.displayName = dn.displayName;
var Pn = T.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ E(_n, {
	ref: r,
	className: e("-mx-1 my-1 h-px bg-muted", t),
	...n
}));
Pn.displayName = _n.displayName;
var Fn = ({ className: t, ...n }) => /* @__PURE__ */ E("span", {
	className: e("ml-auto text-xs tracking-widest opacity-60", t),
	...n
});
Fn.displayName = "DropdownMenuShortcut";
//#endregion
export { An as a, En as c, Fn as d, Tn as f, Sn as h, Cn as i, Mn as l, Dn as m, jn as n, Nn as o, On as p, kn as r, wn as s, xn as t, Pn as u };

//# sourceMappingURL=dropdown-menu-BLAt-Aef.js.map